import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { IAgencyDigest } from '@innerhive-internal/innerhive-common';
import { BRAND, CHART_INK } from './agencyChartTheme';
// Print is hidden for now; InsightsPrintButton, given the sheet's props, restores it.
import { formatLongDate, formatTimeOfDay } from './insightsDates';

const useStyles = createUseStyles({
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        flexWrap: 'wrap' as const,
        marginBottom: -6
    },

    count: {
        fontSize: 13,
        color: CHART_INK.label,
        whiteSpace: 'nowrap' as const
    },

    countValue: {
        fontSize: 18,
        fontWeight: 600,
        color: BRAND.deepTeal,
        fontVariantNumeric: 'tabular-nums'
    },

    windowLine: {
        flex: 1,
        minWidth: 200,
        fontSize: 12.5,
        lineHeight: 1.45,
        color: CHART_INK.label
    }
});

/**
 * The line above the reports: how many clients the figures cover, and when the caseload was read and
 * the window it covers. The count is of the clients whose records could be read; the panel under it
 * names the rest.
 */
export const InsightsToolbar: FC<{ digest: IAgencyDigest }> = ({ digest }) => {
    const classes = useStyles();

    const windowLine = `Caseload read ${formatLongDate(digest.readAt)} at ${formatTimeOfDay(digest.readAt)}, covering the ${digest.windowWeeks} weeks before.`;
    const clients = `${digest.clientCount === 1 ? 'client' : 'clients'}${digest.unreadableCount > 0 ? ' read' : ''}`;

    return (
        <div className={classes.toolbar}>
            <span className={classes.count}>
                <span className={classes.countValue} data-id="insights-client-count">{digest.clientCount}</span> {clients}
            </span>
            <span className={classes.windowLine} data-id="insights-window">{windowLine}</span>
        </div>
    );
};
